import i18n from 'i18n'

const ShowSuccessMsg = ({firstName}) => {
  const isFrench = i18n.language.startsWith('fr')

  return (
    <div
      className='d-flex align-items-center justify-content-center px-3 py-10'
      style={{minHeight: '70vh'}}
    >
      <div className='card border-0 shadow-sm w-100' style={{maxWidth: '850px'}} aria-live='polite'>
        <div className='card-body text-center p-6 p-md-10'>
          <div
            className='d-inline-flex align-items-center justify-content-center rounded-circle bg-light-success mb-6'
            style={{width: '90px', height: '90px'}}
          >
            <i className='fas fa-check-circle text-success' style={{fontSize: '52px'}} />
          </div>

          <h2 className='fw-bold text-gray-900 mb-5'>
            {isFrench
              ? 'Votre demande d’adhésion a bien été reçue'
              : 'Your membership application has been received'}
          </h2>

          <div className='fs-5 text-gray-700 lh-lg'>
            {isFrench ? (
              <>
                <p className='mb-4 text-capitalize'>Bonjour {firstName},</p>

                <p className='mb-4'>
                  Nous vous remercions chaleureusement pour l’intérêt que vous portez à{' '}
                  <b>Horizon Genève</b> et pour votre souhait de rejoindre notre mouvement.
                </p>

                <p className='mb-4'>
                  Votre demande d’adhésion a bien été enregistrée et sera prochainement examinée par
                  l’organe compétent.
                </p>

                <p className='mb-4'>
                  En souhaitant rejoindre Horizon Genève, vous choisissez de participer à une
                  démarche citoyenne, ouverte et responsable, au service de Genève et de sa
                  population.
                </p>
                <p className='mb-4'>
                  Notre équipe vous contactera si des informations ou des documents complémentaires
                  sont nécessaires au traitement de votre demande.
                </p>

                <p className='mb-0'>
                  Avec nos meilleures salutations,
                  <br />
                  Le Service des adhésions
                  <br />
                  Horizon Genève
                </p>
              </>
            ) : (
              <>
                <p className='mb-4 text-capitalize'>Hello {firstName}</p>

                <p className='mb-4'>
                  Thank you for your interest in <b>Horizon Genève</b> and for wishing to join our
                  movement.
                </p>

                <p className='mb-4'>
                  Your membership application has been successfully received and will soon be
                  reviewed by the relevant body.
                </p>

                <p className='mb-4'>
                  By seeking to join Horizon Genève, you are choosing to take part in an open,
                  responsible and citizen-led movement committed to serving Geneva and its
                  residents.
                </p>
                <p className='mb-4'>
                  Our team will contact you if any additional information or documents are required
                  to process your application.
                </p>

                <p className='mb-0'>
                  Kind regards,
                  <br />
                  Membership Services
                  <br />
                  Horizon Genève
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShowSuccessMsg
